<template>
  <div class="air-button">
    <button @click="visible = true">air button</button>
    <slot></slot>
    <a-modal
      title="温馨提示"
      :visible="visible"
    >
      <p>this is a modal</p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'air-button',
  props: {
    circle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false
    }
  }
}
</script>
